import instance from './instance';

export const getHomePageV2Data = params => instance.get('/home_page', { params });

export const homePageTaskAssignedDrop = data => instance.post('/home_page/tasks_drop', data);
